import { render, staticRenderFns } from "./resetPwd1.vue?vue&type=template&id=342eaa16&scoped=true"
import script from "./resetPwd1.vue?vue&type=script&lang=js"
export * from "./resetPwd1.vue?vue&type=script&lang=js"
import style0 from "./resetPwd1.vue?vue&type=style&index=0&id=342eaa16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342eaa16",
  null
  
)

export default component.exports